import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  TextField,
  Box,
  Select,
  MenuItem,
  Button,
  Stack,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Divider from "@mui/material/Divider";

import { apiPost } from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SocialCardContainer = ({
  placeholder,
  icon,
  bgIcon,
  name,
  value,
  onChange,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.social_links_box}>
      <div
        className={classes.social_icon_box}
        style={{ backgroundColor: bgIcon }}
      >
        {icon}
      </div>
      <input
        name={name}
        value={value}
        onChange={onChange}
        className={classes.social_link_input}
        placeholder={placeholder}
      />
    </div>
  );
};

const useStyles = makeStyles({
  outlineInputBorder: {
    width: "100%",
    "& * > input": {
      padding: "5px 14px !important",
    },
    "& > fieldset > legend > span": {
      display: "none",
    },
    "& * > fieldset": {
      top: "0 !important",
    },
    "& * > fieldset > legend": {
      display: "none !important",
    },
  },
  playerprofilebtn: {
    backgroundColor: "#06623B !important",
    color: "#FFF !important",
    borderRadius: "5px !important",
    fontWeight: "400 !important",
    minWidth: "175px !important",
    padding: "10px 20px !important",
    textTransform: "capitalize !important",
  },
  fb_button: {
    backgroundColor: "#3B5998 !important",
    color: "#FFF !important",
    textTransform: "capitalize !important",
    fontSize: 18,
    width: "100%",
    height: 40,
    borderRadius: "4px 4px 0 0 !important",
  },
  twitter_button: {
    backgroundColor: "#55ACEE !important",
    color: "#FFF !important",
    textTransform: "capitalize !important",
    fontSize: 18,
    width: "100%",
    height: 40,
    borderRadius: "4px 4px 0 0 !important",
  },
  instagram_button: {
    backgroundColor: "#09416A !important",
    color: "#FFF !important",
    textTransform: "capitalize !important",
    fontSize: 18,
    width: "100%",
    height: 40,
    borderRadius: "4px 4px 0 0 !important",
  },
  linkedIn_button: {
    backgroundColor: "#0E76A8 !important",
    color: "#FFF !important",
    textTransform: "capitalize !important",
    fontSize: 18,
    width: "100%",
    height: 40,
    borderRadius: "4px 4px 0 0 !important",
  },
  divider: {
    width: "2% !important",
    height: "100% !important",
  },
  social_icon_box: {
    padding: "4px",
    borderRadius: "6px",
  },
  social_links_box: {
    padding: "6px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    display: "flex",
  },
  social_link_input: {
    width: "100%",
    border: "transparent",
    outline: "none",
    paddingLeft: "8px",
    fontSize: "14px",
  },
});

function NewPlayerCard() {
  const classes = useStyles();
  const [formValues, setFormValues] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    company: "",
    website: "",
    user_role: "Player",
    role_in_company: "",
    member_since: "",
    unique_initials: "",
    default_tee: "",
    password: "",
    social_links: {
      facebook: "",
      twitter: "",
      instagram: "",
      linkedin: "",
    },
  });
  const [guestValues, setGuestValues] = useState({
    first_name: "",
    last_name: "",
    email: "",
    blue_tee: "",
    white_tee: "",
    yellow_tee: "",
    black_tee: "",
    handicap: "",
    default_tee: "",
  });

  const [Years, setYears] = useState(["2022"]);

  const navigate = useNavigate();

  const handleCreateNewPlayer = () => {
    if (formValues.user_role === "Guest") {
      if (guestValues.handicap === "") {
        return toast.error("Enter W.H.I");
      }

      if (guestValues.first_name === "") {
        return toast.error("Enter First Name");
      }

      if (guestValues.last_name === "") {
        return toast.error("Enter Last Name");
      }

      if (guestValues.email === "") {
        return toast.error("Enter Email Address");
      }

      if (guestValues.white_tee === "") {
        return toast.error("Enter White Tee");
      }

      if (guestValues.yellow_tee === "") {
        return toast.error("Enter Yellow Tee");
      }

      if (guestValues.blue_tee === "") {
        return toast.error("Enter Blue Tee");
      }

      if (guestValues.black_tee === "") {
        return toast.error("Enter Black Tee");
      }

      if (guestValues.default_tee === "") {
        return toast.error("Select Default Tee");
      }

      let user_tee = [
        {
          handicap_value: guestValues.white_tee,
          tee_color: "white",
          is_default: guestValues.default_tee === "White" ? true : false,
        },
        {
          handicap_value: guestValues.yellow_tee,
          tee_color: "yellow",
          is_default: guestValues.default_tee === "Yellow" ? true : false,
        },
        {
          handicap_value: guestValues.blue_tee,
          tee_color: "blue",
          is_default: guestValues.default_tee === "Blue" ? true : false,
        },
        {
          handicap_value: guestValues.black_tee,
          tee_color: "black",
          is_default: guestValues.default_tee === "Black" ? true : false,
        },
      ];

      let userData = {
        first_name: guestValues.first_name,
        last_name: guestValues.last_name,
        email: guestValues.email,
        user_tee,
        handicap: guestValues.handicap,
        user_role: "Guest",
        password: "000000",
      };

      apiPost(`${ApiEndpoints.user.addGuest}`, userData, (res) => {
        if (res.error) {
          toast.error(res.message);
        } else {
          toast.success(res.message);
        }
      });
    } else {
      if (formValues.unique_initials === "") {
        return toast.error("Enter Unique Initials");
      }

      if (formValues.default_tee === "") {
        return toast.error("Select Default Tee");
      }

      if (formValues.first_name === "") {
        return toast.error("Enter First Name");
      }

      if (formValues.last_name === "") {
        return toast.error("Enter Last Name");
      }

      if (formValues.email === "") {
        return toast.error("Enter Email Address");
      }

      if (formValues.mobile_number === "") {
        return toast.error("Enter Mobile Number");
      }

      if (formValues.password === "") {
        return toast.error("Enter Password");
      }

      let userData = {
        first_name: formValues.first_name,
        last_name: formValues.last_name,
        email: formValues.email,
        mobile_no: formValues.mobile_number,
        unique_initials: formValues.unique_initials,
        default_tee: formValues.default_tee,
        user_role: [formValues.user_role],
        company: formValues.company,
        website: formValues.website,
        member_since: formValues.member_since,
        social_links: [
          { name: "facebook", link: formValues.social_links.facebook },
          { name: "twitter", link: formValues.social_links.twitter },
          { name: "instagram", link: formValues.social_links.instagram },
          { name: "linkedin", link: formValues.social_links.linkedin },
        ],
        password: formValues.password,
      };

      apiPost(
        `${ApiEndpoints.users.base}`,
        userData,
        (res) => {
          if (res.error) {
            toast.error(res.message);
          } else {
            toast.success(res.message);
          }
        },
        (err) => {
          toast.error(err.message);
        }
      );
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormValues((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };

  const handleGuestInputChange = (e) => {
    const { name, value } = e.target;

    setGuestValues((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    var l_Year = Years;
    for (var i = "2021"; i >= "2000"; i--) {
      l_Year.push(i.toString());
    }
    setYears(l_Year);

    setFormValues({
      ...formValues,
      member_since: l_Year[0],
    });
  }, []);

  return (
    <Grid container p={3}>
      <Grid item xs={12} marginBottom={3} mt={2}>
        <Grid
          item
          container
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Grid item>
            <Button
              className={classes.playerprofilebtn}
              onClick={() => {
                navigate("/players-area");
              }}
            >
              Back
            </Button>
          </Grid>
          <Grid item>
            <Stack direction="row" spacing={2}></Stack>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontWeight: "700", pb: "2px" }}>
          New Player Registration
        </Typography>
        <Divider
          orientation="horizontal"
          sx={{ height: "3px !important", margin: "7px 0 30px" }}
        />

        <Grid container columnSpacing={6} marginTop="50px" marginBottom="50px">
          <Grid
            item
            xs={12}
            md={6}
            borderRight={{ xs: "none", md: "2px solid #ccc" }}
          >
            <Grid container>
              <Grid item xs={12} md={10} lg={8}>
                <Grid container alignItems="center" marginBottom="20px">
                  <Grid item xs={12} md={5}>
                    <Typography variant="subtitle2" fontWeight={"700"}>
                      User Type <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <Select
                      variant="outlined"
                      value={formValues.user_role}
                      onChange={(e) => handleInputChange(e)}
                      className={classes.outlineInputBorder}
                      name="user_role"
                      label="."
                    >
                      {["Admin", "Player", "Guest"].map((item) => (
                        <MenuItem key={item} value={item}>
                          <Grid container item>
                            <Grid item xs={10}>
                              {item}
                            </Grid>
                          </Grid>
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
                {formValues.user_role !== "Guest" ? (
                  <>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Member Since
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          name="member_since"
                          value={formValues.member_since}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Unique Initials{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          name="unique_initials"
                          value={formValues.unique_initials}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Default Tee <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <Select
                          variant="outlined"
                          value={formValues.default_tee}
                          onChange={(e) => handleInputChange(e)}
                          className={classes.outlineInputBorder}
                          name="default_tee"
                          fullWidth
                          label="."
                          placeholder="Inactive"
                        >
                          {["White", "Blue", "Yellow", "Black"].map((item) => (
                            <MenuItem
                              key={item}
                              // setStatus={item.name}
                              value={item}
                              onClick={() => {}}
                            >
                              <Grid container item>
                                <Grid item xs={10}>
                                  {item}
                                </Grid>
                              </Grid>
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          W.H.I
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          name="handicap"
                          value={guestValues.handicap}
                          onChange={(e) => handleGuestInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container>
              {/*marginX: 'auto' from centered container  */}
              <Grid item xs={12} md={10} lg={8}>
                {formValues.user_role === "Guest" ? (
                  <>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          First Name <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          name="first_name"
                          value={guestValues.first_name}
                          onChange={(e) => handleGuestInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Last Name <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          name="last_name"
                          value={guestValues.last_name}
                          onChange={(e) => handleGuestInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Email <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          name="email"
                          value={guestValues.email}
                          onChange={(e) => handleGuestInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          White Tee <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          name="white_tee"
                          value={guestValues.white_tee}
                          onChange={(e) => handleGuestInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Yellow Tee <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          name="yellow_tee"
                          value={guestValues.yellow_tee}
                          onChange={(e) => handleGuestInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Blue Tee <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          name="blue_tee"
                          value={guestValues.blue_tee}
                          onChange={(e) => handleGuestInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Black Tee <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          name="black_tee"
                          value={guestValues.black_tee}
                          onChange={(e) => handleGuestInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Default Tee <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <Select
                          variant="outlined"
                          value={guestValues.default_tee}
                          onChange={(e) => handleGuestInputChange(e)}
                          className={classes.outlineInputBorder}
                          name="default_tee"
                          fullWidth
                          label="."
                          placeholder="Inactive"
                        >
                          {["White", "Blue", "Yellow", "Black"].map((item) => (
                            <MenuItem
                              key={item}
                              // setStatus={item.name}
                              value={item}
                            >
                              <Grid container item>
                                <Grid item xs={10}>
                                  {item}
                                </Grid>
                              </Grid>
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          First Name <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          name="first_name"
                          value={formValues.first_name}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Last Name <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          name="last_name"
                          value={formValues.last_name}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Email <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          sx={{
                            backgroundColor: "transparent",
                            color: "#000000",
                          }}
                          className={classes.outlineInputBorder}
                          name="email"
                          value={formValues.email}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Mobile No <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          sx={{
                            backgroundColor: "transparent",
                            color: "#000000",
                          }}
                          className={classes.outlineInputBorder}
                          name="mobile_number"
                          value={formValues.mobile_number}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Company
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          sx={{
                            backgroundColor: "transparent",
                            color: "#000000",
                          }}
                          className={classes.outlineInputBorder}
                          name="company"
                          value={formValues.company}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Website
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          sx={{
                            backgroundColor: "transparent",
                            color: "#000000",
                          }}
                          className={classes.outlineInputBorder}
                          name="website"
                          value={formValues.website}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ marginBottom: "20px" }}
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" fontWeight={"600"}>
                          Password
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          className={classes.outlineInputBorder}
                          type="password"
                          name="password"
                          value={formValues.password}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: "700", pb: "2px" }}>
            Social Links
          </Typography>
          <Divider
            orientation="horizontal"
            sx={{ height: "3px !important", margin: "7px 0 30px" }}
          />
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <SocialCardContainer
              placeholder="www.facebook.com"
              icon={<FacebookIcon sx={{ color: "white" }} />}
              bgIcon="#3B5998"
              name="facebook"
              value={formValues.social_links.facebook}
              onChange={(e) => {
                setFormValues((pre) => {
                  return {
                    ...pre,
                    social_links: {
                      ...pre.social_links,
                      [e.target.name]: e.target.value,
                    },
                  };
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SocialCardContainer
              placeholder="www.twitter.com"
              icon={<TwitterIcon sx={{ color: "white" }} />}
              bgIcon="#55ACEE"
              name="twitter"
              value={formValues.social_links.twitter}
              onChange={(e) => {
                setFormValues((pre) => {
                  return {
                    ...pre,
                    social_links: {
                      ...pre.social_links,
                      [e.target.name]: e.target.value,
                    },
                  };
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SocialCardContainer
              placeholder="www.instagram.com"
              icon={<InstagramIcon sx={{ color: "white" }} />}
              bgIcon="#FF3E83"
              name="instagram"
              value={formValues.social_links.instagram}
              onChange={(e) => {
                setFormValues((pre) => {
                  return {
                    ...pre,
                    social_links: {
                      ...pre.social_links,
                      [e.target.name]: e.target.value,
                    },
                  };
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SocialCardContainer
              placeholder="www.linkedin.com"
              icon={<LinkedInIcon sx={{ color: "white" }} />}
              bgIcon="#3B5998"
              name="linkedin"
              value={formValues.social_links.linkedin}
              onChange={(e) => {
                setFormValues((pre) => {
                  return {
                    ...pre,
                    social_links: {
                      ...pre.social_links,
                      [e.target.name]: e.target.value,
                    },
                  };
                });
              }}
            />
          </Grid>
        </Grid>

        <Box sx={{ marginTop: "40px", textAlign: "right" }}>
          <Button
            className={classes.playerprofilebtn}
            onClick={() => handleCreateNewPlayer()}
          >
            Create
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}

export default NewPlayerCard;
